export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx1d_sell.0972798c.mp3";